import React, { useState, useRef, useEffect } from 'react';
import { 
  ChartBarIcon, 
  ShareIcon, 
  ClockIcon, 
  CogIcon, 
  ArrowRightOnRectangleIcon,
  EnvelopeIcon,
  ArrowLeftOnRectangleIcon 
} from '@heroicons/react/24/solid';

import { MessageSquareDot } from 'lucide-react';

import { useAuth } from '../utils/AuthContext';
import { useNavigate } from 'react-router-dom';

import ShareHubberModal from "./ShareHubberModal";
import FeedbackModal from "./FeedbackModal";

import Cookies from 'js-cookie';

const Profile = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { token, logout } = useAuth();
  const navigate = useNavigate();

  const [LettersIcon, setLettersIcon] = useState('');
  const [FirstName, setFirstName] = useState('');
  const [LastName, setLastName] = useState('');

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFeedModalOpen, setIsFeedModalOpen] = useState(false);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const url = "https://tuly.app";

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const getUserInfo = async () => {
    Cookies.get('fname');

    const letters = Cookies.get('fname').charAt(0) + Cookies.get('lname').charAt(0);

    setLettersIcon(letters); //Set Profile Icon Letters
    setFirstName(Cookies.get('fname'));
    setLastName(Cookies.get('lname'));
  };

  useEffect(() => {

    getUserInfo();

    document.addEventListener('mousedown', handleClickOutside);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };

  }, []);

  const ProfileMenuItem = ({ icon: Icon, label, onClick, href }) => (
    <a onClick={onClick}
      className="group flex items-center px-4 py-2 hover:bg-blue-50 transition-colors duration-200 rounded-lg">
      {Icon && (
        <Icon className="h-5 w-5 mr-3 text-blue-500 group-hover:text-blue-700 transition-colors" />
      )}
      <span className="text-gray-700 group-hover:text-blue-800 font-medium">{label}</span>
    </a>
  );

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Profile Trigger */}
      <button onClick={toggleDropdown} 
        className="flex items-center justify-center w-10 h-10 bg-gradient-to-br from-blue-400 to-blue-600 rounded-full shadow-md hover:shadow-lg transition-all">
        <span className="text-white font-semibold">{LettersIcon}</span>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-72 bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden animate-fade-in-down">
          {/* Profile Header */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-700 p-4 text-white">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mr-3">
                <span className="text-white font-bold">{LettersIcon}</span>
              </div>
              <div>
                <h3 className="font-bold text-lg">{FirstName} {LastName}</h3>
                <p className="text-sm text-blue-100">Tuly's Friend</p>
              </div>
            </div>
          </div>

          {/* Menu Sections */}
          <div className="py-2">
            <div className="px-4 py-2 text-xs text-gray-500 uppercase">Sharing ..</div>
            {/*<ProfileMenuItem 
              icon={ClockIcon} 
              label="Search History" 
              href="/history"
            />*/}
            <ProfileMenuItem 
              icon={ShareIcon} 
              label="Tell Others!" 
              onClick={() => setIsModalOpen(true)}
            />
          </div>

          <hr className="my-2 border-gray-200" />

          <div className="py-2">
            <div className="px-4 py-2 text-xs text-gray-500 uppercase">Help & Feedback</div>
            <ProfileMenuItem 
              icon={MessageSquareDot}
              label="How is Tuly?" 
              onClick={() => setIsFeedModalOpen(true)}
            />
          </div>

          {isModalOpen && (
            <ShareHubberModal 
              url={url} 
              onClose={() => setIsModalOpen(false)} 
            />
          )}

          {isFeedModalOpen && (
            <FeedbackModal 
              onClose={() => setIsFeedModalOpen(false)} 
            />
          )}


          <hr className="my-2 border-gray-200" />

          <div className="py-2">
            {!token ? (
              <ProfileMenuItem 
                icon={ArrowRightOnRectangleIcon} 
                label="Login" 
                onClick={() => navigate('/login')}
              />
            ) : (
              <ProfileMenuItem 
                icon={ArrowLeftOnRectangleIcon} 
                label="Logout" 
                onClick={() => {
                  logout();
                  navigate('/landing');
                }}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Profile;